import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../sd-environment';
import { HttpMethods } from '../_enums/http-methods.enum';

interface HttpOptions {
  headers: HttpHeaders;
  params: HttpParams;
  responseType: any;
  observe: any;
  reportProgress: boolean;
}

@Injectable()
export abstract class RestService {
  baseApiUrl: string;

  private static constructOptions(
    headers: HttpHeaders,
    params: HttpParams,
    observe = 'body',
  ): HttpOptions {
    return {
      headers,
      params: params ? params : null,
      responseType: 'json',
      observe,
      reportProgress: false
    };
  }

  constructor(protected http: HttpClient) {
    this.baseApiUrl =
      environment.baseUrl + environment.apiUrl + '/' + environment.baseSiteId;
  }

  protected get headers(): HttpHeaders {
    return new HttpHeaders();
  }

  callApi(
    method: HttpMethods,
    resourcePath: string,
    body?: any,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isHandleError = true,
    params?: HttpParams,
    headers?: HttpHeaders,
    observe?: string,
  ): Observable<any> {
    const callUrl = this.baseApiUrl + resourcePath;

    if (headers) {
      headers
        .keys()
        .forEach((key: string) => this.headers.append(key, headers.get(key)));
    }

    if (method === HttpMethods.POST || method === HttpMethods.PUT) {
      this.headers.append('Content-Type', 'application/json');
    }

    const options = RestService.constructOptions(this.headers, params, observe);

    switch (method) {
      case HttpMethods.POST:
        return this.http.post(callUrl, body, options).pipe(
          catchError((err) => {
            console.error(err);
            return throwError(err);
          }),
        );
      case HttpMethods.PUT:
        return this.http.put(callUrl, body, options).pipe(
          catchError((err) => {
            console.error(err);
            return throwError(err);
          }),
        );
      case HttpMethods.GET:
        return this.http.get(callUrl, options).pipe(
          catchError((err) => {
            console.error(err);
            return throwError(err);
          }),
        );
      case HttpMethods.DELETE:
        return this.http.delete(callUrl, options).pipe(
          catchError((err) => {
            console.error(err);
            return throwError(err);
          }),
        );
    }
  }
}
